export const MAIL_TEMPLATE_KEYS = {
  AUTH_VERIFY_EMAIL: 'auth.verify_email',
  AUTH_PASSWORD_RESET: 'auth.password_reset',
  AUTH_EMAIL_CHANGE: 'auth.email_change',
  AUTH_SECURITY_ALERT: 'auth.security_alert',
  AUTH_MEMBER_WELCOME: 'auth.member_welcome',
  AUTH_CREATOR_WELCOME: 'auth.creator_welcome',
  BILLING_RECEIPT: 'billing.receipt',
  NOTIFICATION_MENTION_MISSED: 'notification.mention_missed',
  NOTIFICATION_DM_MISSED: 'notification.dm_missed',
  NOTIFICATION_DAILY_DIGEST: 'notification.daily_digest',
  NOTIFICATION_WEEKLY_DIGEST: 'notification.weekly_digest',
  NOTIFICATION_IMMEDIATE: 'notification.immediate',
  SYSTEM_LAYOUT: 'system.layout',
  PLATFORM_ANNOUNCEMENT: 'platform.announcement',
  COMMUNITY_BROADCAST: 'community.broadcast',
  COURSE_PURCHASE_RECEIPT: 'course.purchase_receipt',
  COURSE_ENROLLED: 'course.enrolled',
  COURSE_DRIP_UNLOCK: 'course.drip_unlock',
  COURSE_CERTIFICATE_READY: 'course.certificate_ready',
  MEMBERSHIP_PERK_DELIVERED: 'membership.perk_delivered',
  MEMBERSHIP_SUBSCRIPTION_RECEIPT: 'membership.subscription_receipt',
  MEMBERSHIP_WELCOME: 'membership.welcome',
  MEMBERSHIP_BILLING_PAST_DUE: 'membership.billing_past_due',
  MEMBERSHIP_CANCELLED: 'membership.cancelled',
} as const;

export type MailTemplateKey = (typeof MAIL_TEMPLATE_KEYS)[keyof typeof MAIL_TEMPLATE_KEYS];
